import { render, staticRenderFns } from "./NewsBW2026Tokyo.vue?vue&type=template&id=1ba44f0e&scoped=true&"
import script from "./NewsBW2026Tokyo.vue?vue&type=script&lang=js&"
export * from "./NewsBW2026Tokyo.vue?vue&type=script&lang=js&"
import style0 from "./NewsBW2026Tokyo.vue?vue&type=style&index=0&id=1ba44f0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba44f0e",
  null
  
)

export default component.exports